import React from 'react';
import { StarIcon } from 'lucide-react';
export function StarRating({
  rating,
  size = 'sm'
}: {
  rating: number;
  size?: 'sm' | 'md';
}) {
  const cls = size === 'md' ? 'h-4 w-4' : 'h-3.5 w-3.5';
  return <span className="flex" role="img" aria-label={`Rated ${rating} out of 5`} data-id="element-434" data-mp="3dmn403x5ww2m">
      {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className={`${cls} ${i < Math.round(rating) ? 'fill-amber-400 text-amber-400' : 'fill-line text-line'}`} aria-hidden="true" data-id="element-435" data-mp="3imrad14cwaf4" />)}
    </span>;
}